// Import translations helper
import translations from "../utility/translations";
import config from "../utility/config";

// Set initial state
const state = {
  loading: true,
  searchParams: {
    search: null,
    page: 1,
    pagesize: 12,
    tags: [],
  },
  recipes: {
    data: [],
    meta: {
      page: null,
      pages: null,
      count: null,
      partialMatches: null,
      perfect_matches: null,
    },
  },
  currentRecipe: {
    servings: {
      quantity: null,
      image: "",
      unit: {
        zero: null,
        one: null,
        two: null,
        few: null,
        many: null,
        other: null,
      },
    },
    ingredients: [],
    formulationSteps: [],
    utensils: [],
    tags: []
  },
  slides: {
    data: [],
  },
  groups: {
    data: [],
  },
  translations,
  config,
};

export default state;
